"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ADD_DRAFT: function() {
        return ADD_DRAFT;
    },
    DELETE_DRAFT: function() {
        return DELETE_DRAFT;
    },
    DUPLICATE_DRAFT: function() {
        return DUPLICATE_DRAFT;
    },
    GENERATE_DRAFTS: function() {
        return GENERATE_DRAFTS;
    },
    RESET_DRAFTS: function() {
        return RESET_DRAFTS;
    },
    UPDATE_DRAFT: function() {
        return UPDATE_DRAFT;
    }
});
const ADD_DRAFT = "ADD_DRAFT";
const UPDATE_DRAFT = "UPDATE_DRAFT";
const DELETE_DRAFT = "DELETE_DRAFT";
const GENERATE_DRAFTS = "GENERATE_DRAFTS";
const RESET_DRAFTS = "RESET_DRAFTS";
const DUPLICATE_DRAFT = "DUPLICATE_DRAFT";
